export interface FlatFileObjectConfigFormReducerState {
  inferSchemaTaskId: string | null;
  inferSchemaRunning: boolean;
  inferSchemaError: string | null;
  inferSchemaSuccessful: boolean;
  objectId: string | null;
}

export enum FlatFileObjectConfigFormReducerActionType {
  INIT_INFER_SCHEMA = 'INIT_INFER_SCHEMA',
  SAVE_INFER_SCHEMA_ERROR = 'SAVE_INFER_SCHEMA_ERROR',
  SAVE_INFER_SCHEMA_SUCCESS = 'SAVE_INFER_SCHEMA_SUCCESS',
  SAVE_INFER_SCHEMA_TASK_ID = 'SAVE_INFER_SCHEMA_TASK_ID'
}

export interface FlatFileObjectConfigFormReducerAction {
  type: FlatFileObjectConfigFormReducerActionType;
  data?: Partial<FlatFileObjectConfigFormReducerState>;
}

export type FlatFileObjectConfigFormReducerType = (
  state: FlatFileObjectConfigFormReducerState,
  action: FlatFileObjectConfigFormReducerAction
) => FlatFileObjectConfigFormReducerState;
